import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNotificationsSnackbar } from '@/components/snackbar/NotificationsSnackbarContext';
import { EPOSSetupRequest, TitanPlanRequest } from '@/models/payment';
import { useAppDispatch } from '@/lib/hooks';
import {} from '@/services/paymentsQuery';
import { TwoInputConnection } from '@/pages/company/common/TwoInputConnection';
import { usePaymentsMutations } from '@/services/paymentsMutations';
import { useHandleResponse } from '@/lib/hooks/useHandleResponse';
import { InputText } from '@/components/shared/InputText';
import { Box, Grid } from '@mui/material';
import {
    PrimaryButtonStyle,
    SecondaryButtonStyle
} from '@/pages/company/common/IntegrationDialog';
interface EposConnectProps {
    onClose?: () => void;
    onSaveSuccess: any;
}

export const EposConnect = (props: EposConnectProps) => {
    const { t } = useTranslation();
    const [eposData, setEposData] = useState<EPOSSetupRequest>({} as any);
    const { eposSetup } = usePaymentsMutations();
    const onClick = () => {
        eposSetup.mutate(eposData);
    };

    useHandleResponse({
        isSuccess: eposSetup.isSuccess,
        error: eposSetup.error,
        isPending: eposSetup.isPending,
        successAlertMessage: t('connected'),
        isSuccessCallBack: () => {
            props.onSaveSuccess();
        }
    });

    return (
        <>
            <Box width={'100%'} margin={'20px 0 10px'}>
                <InputText
                    value={eposData.username || ''}
                    label={t('username')}
                    onChange={(e) => {
                        setEposData({ ...eposData, username: e.target.value });
                    }}
                    spacing="10px 0"
                />

                <InputText
                    value={eposData.password || ''}
                    type="password"
                    label={t('password')}
                    onChange={(e) => {
                        setEposData({ ...eposData, password: e.target.value });
                    }}
                    spacing="10px 0"
                />

                <InputText
                    value={eposData.instapaidServiceFeeCode || ''}
                    label={t('instapaid_service_fee_code')}
                    onChange={(e) => {
                        setEposData({
                            ...eposData,
                            instapaidServiceFeeCode: e.target.value
                        });
                    }}
                />
                <InputText
                    value={eposData.instapaidSalaryRecordCode || ''}
                    label={t('instapaid_salary_record_code_optional')}
                    onChange={(e) => {
                        setEposData({
                            ...eposData,
                            instapaidSalaryRecordCode: e.target.value
                        });
                    }}
                />
            </Box>

            <Grid m={'20px 0'} container justifyContent={'space-around'}>
                <SecondaryButtonStyle
                    onClick={props.onClose}
                    sx={{ width: '170px' }}
                >
                    {t('back')}
                </SecondaryButtonStyle>

                <PrimaryButtonStyle onClick={onClick} sx={{ width: '170px' }}>
                    {t('connect')}
                </PrimaryButtonStyle>
            </Grid>
        </>
    );
};
